class ProductMedia extends HTMLElement {
    // connect component
    connectedCallback() {
        const breakpoint = window.matchMedia("(max-width: 990px)");
        let productMediaSlider;
        let onClick;
        const checkBreakpoint = function () {
            const allSliders = document.querySelectorAll('.swiper-product-media');
            allSliders.forEach(slider => {
                if (slider.dataset.desktopLayout === "slider") {
                    enableSlider(slider);
                } else {
                    // display in stacked format on desktop
                    if (breakpoint.matches === false) {
                        disableSlider(slider);
                        // Scroll to initial image on page load for stacked layout
                        scrollToInitialImage(slider);
                    // display in slider format on mobile
                    } else if (breakpoint.matches === true) {
                        if (!slider.classList.contains("swiper-initialized")) {
                            enableSlider(slider);
                        }
                    }
                }
                if (breakpoint.matches === false) {
                    return enableZoom();
                // don't enable zoom on mobile.
                } else if (breakpoint.matches === true) {
                    return disableZoom();
                }
            });
        }
        const enableSlider = function (slider) {
            const sliderId = slider.id;
            slider.classList.remove("product-grid");
            let slideCount = slider.querySelectorAll(".swiper-slide:not(.swiper-slide-duplicate)").length;
            const thumbsId = `${sliderId}--thumbs`;

            // Get initial slide from data attribute (set by Liquid based on selected variant)
            const initialSlide = parseInt(slider.dataset.initialSlide) || 0;

            let thumbsSwiper;
            if (document.getElementById(thumbsId)) {
                thumbsSwiper = new Swiper(`#${thumbsId}`, {
                    loop: false,
                    slidesPerView: 5,
                    spaceBetween: 0,
                    initialSlide: initialSlide,
                    direction: 'vertical',
                });
            }
            if (slideCount > 1) {
                productMediaSlider = new Swiper(`#${sliderId}`, {
                    loop: true,
                    initialSlide: initialSlide,
                    spaceBetween: 1,
                    centeredSlides: true,
                    centeredSlidesBounds: true,
                    watchOverflow: true,
                    watchSlidesVisibility: true,
                    watchSlidesProgress: true,

                    zoom: {
                        maxRatio: 5,
                        containerClass: `swiper-zoom-container`
                    },
                    pagination: {
                        el: `#${sliderId} .swiper-pagination`,
                        clickable: true
                    },
                    navigation: {
                        nextEl: `#${sliderId} .swiper-button-next`,
                        prevEl: `#${sliderId} .swiper-button-prev`
                    },
                    thumbs: {
                        swiper: thumbsSwiper,
                        direction: 'vertical',
                    },
                });
            }
        }

        const disableSlider = function () {
            if (productMediaSlider !== undefined) {
                productMediaSlider.destroy(true, true);
            }
        }

        const scrollToInitialImage = function (slider) {
            // Only scroll on initial page load, not every time layout changes
            if (slider.dataset.initialScrollDone) return;
            slider.dataset.initialScrollDone = 'true';

            const initialSlide = parseInt(slider.dataset.initialSlide) || 0;
            if (initialSlide === 0) return; // Already at first image

            const slides = slider.querySelectorAll('.swiper-slide');
            if (slides[initialSlide]) {
                const targetSlide = slides[initialSlide];
                const stickyHeader = document.querySelector('sticky-header');
                const headerOffset = stickyHeader ? stickyHeader.offsetHeight : 0;

                const scrollPosition = targetSlide.getBoundingClientRect().top + window.pageYOffset - headerOffset;
                window.scrollTo({ top: scrollPosition, behavior: 'smooth' });
            }
        }

        const enableZoom = function () {
            document.getElementById("MainProduct").classList.add("product-grid");
            let slides = document.getElementsByClassName("swiper-zoom-container");
            Array.from(slides).forEach((slide) => {
                const onMouseMove = function (event) {
                    const x = event.offsetX / slide.offsetWidth * 100
                    const y = event.offsetY / slide.offsetHeight * 100
                    slide.style.backgroundPosition = x + '% ' + y + '%';
                }
                // remove zoom
                const onMouseOut = function () {
                    slide.removeEventListener("mousemove", onMouseMove);
                    slide.removeEventListener("mouseout", onMouseOut);
                    slide.classList.remove("js-zoom-container");
                    slide.style.backgroundImage = "";
                }
                const onClick = function () {
                    let imageUrl = slide.children[0].src;
                    slide.style.backgroundImage = `url(${imageUrl})`;
                    slide.classList.add("js-zoom-container");
                    slide.addEventListener("mousemove", onMouseMove);
                    slide.addEventListener("mouseout", onMouseOut);
                }
                slide.addEventListener("click", onClick);
            });
        }

        const disableZoom = function () {
            let slides = document.getElementsByClassName("swiper-zoom-container");
            Array.from(slides).forEach((slide) => {
                slide.removeEventListener("click", onClick);
            });
        }

        breakpoint.addListener(checkBreakpoint);
        checkBreakpoint(); // first check
    }
}


customElements.define('product-media', ProductMedia);